import React, { createContext, useContext, useState, useEffect, ReactNode, useMemo } from "react";

import { Cookies } from "react-cookie-consent";

type ConsentType = string | undefined;

interface ConsentContextType {
  consent: ConsentType;
  setConsent: (value: ConsentType) => void;
  forceBanner: boolean;
  setForceBanner: (value: boolean) => void;
}

const ConsentContext = createContext<ConsentContextType | undefined>(undefined);

export const ConsentProvider = ({ children }: { children: ReactNode }) => {
  const [consent, setConsent] = useState<ConsentType>(undefined);
  const [forceBanner, setForceBanner] = useState<boolean>(false);

  useEffect(() => {
    const storedConsent = Cookies.get("userConsent");
    setConsent(storedConsent);
  }, []);

  const contextValue = useMemo(() => ({ consent, setConsent, forceBanner, setForceBanner }), [consent, forceBanner]);

  return <ConsentContext.Provider value={contextValue}>{children}</ConsentContext.Provider>;
};

export const useConsent = (): ConsentContextType => {
  const context = useContext(ConsentContext);
  if (!context) {
    throw new Error("useConsent must be used within a ConsentProvider");
  }
  return context;
};
